import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  bufferCount,
  catchError,
  exhaustMap,
  filter,
  map,
  tap,
} from 'rxjs/operators';
import { makeErrorSerializable } from '../../../util/serialization-utils';
import { WindowRef } from '../../../window/window-ref';
import { SiteConnector } from '../../connectors/site.connector';
import { SiteContextActions } from '../actions/index';
import { getActiveLanguage } from '../selectors/languages.selectors';
import { StateWithSiteContext } from '../state';

@Injectable()
export class LanguagesEffects {
  loadLanguages$: Observable<
    | SiteContextActions.LoadLanguagesSuccess
    | SiteContextActions.LoadLanguagesFail> = createEffect (
    () => this.actions$.pipe(
      ofType(SiteContextActions.LOAD_LANGUAGES),
      exhaustMap(() => {
        return this.siteConnector.getLanguages().pipe(
          map(
            (languages) => new SiteContextActions.LoadLanguagesSuccess(languages)
          ),
          catchError((error) =>
            of(
              new SiteContextActions.LoadLanguagesFail(
                makeErrorSerializable(error)
              )
            )
          )
        );
      })
    )
  );


  persist$ = createEffect(
    () => this.actions$.pipe(
      ofType(SiteContextActions.SET_ACTIVE_LANGUAGE),
      tap((action: SiteContextActions.SetActiveLanguage) => {
        if (this.winRef.sessionStorage) {
          this.winRef.sessionStorage.setItem('language', action.payload);
        }
      }),
    ),
    { dispatch: false }
  );


  activateLanguage$: Observable<
    SiteContextActions.LanguageChange > = createEffect(
    () => this.state.select(getActiveLanguage).pipe(
      bufferCount(2, 1),
      // avoid dispatching `change` action when we're just setting the initial value:
      filter(([previous]) => !!previous),
      map(
        ([previous, current]) =>
          new SiteContextActions.LanguageChange({ previous, current })
      )
    )
  );


  constructor(
    private actions$: Actions,
    private siteConnector: SiteConnector,
    private winRef: WindowRef,
    private state: Store<StateWithSiteContext>
  ) {}
}
